// ./src/components/loadings/LoadingList/styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 10vh 5vw 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
